import { Navigate, useLocation } from 'react-router-dom';
import { AppRoute } from '../../enums/appRoutes';

export const FallbackRedirect = () => {
  const location = useLocation();
  return <Navigate to={`${AppRoute.APPLIANCE_DETAILS}${location.search}`} replace />;
};
